import React, { FC } from "react";

import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { ObjectTypeIcon } from "@/components/atoms";
import { SearchResult } from "@/shared/apis/searchApi";

import { getSearchItemId } from "../utils/searchItemId";
import { searchHighlightClassName } from "../utils/useSearch";

type ResultsListProps = {
    results: SearchResult[];
    openEntry: (Event, SearchResult) => void;
    setFocus: React.Dispatch<React.SetStateAction<SearchResult>>;
    focus: SearchResult;
    labelledby: string;
};

const ResultsList: FC<ResultsListProps> = ({ focus, openEntry, setFocus, results, labelledby }) => {
    return (
        <List role="listbox" aria-labelledby={labelledby}>
            {results.map((item) => (
                <ListItem
                    role="option"
                    onMouseEnter={() => setFocus(item)}
                    aria-selected={focus === item}
                    aria-disabled={!item.isAccessible}
                    disablePadding
                    key={getSearchItemId(item)}
                >
                    <ListItemButton
                        onClick={(event) => openEntry(event, item)}
                        disabled={!item.isAccessible}
                        id={getSearchItemId(item)}
                    >
                        <ListItemIcon>
                            <ObjectTypeIcon type={item.type} />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: searchHighlightClassName, secondary: searchHighlightClassName }}
                            primary={item.name}
                            secondary={item.description}
                        />
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    );
};

export default ResultsList;
